class SlateOverrides {

    constructor(){
        this.init();
    }

    init(){
        //Slate forms INSIST on adding row_hover to our tables which breaks them it's crazy
        setTimeout(() => {
            const tableRows = document.querySelectorAll('tr.row_hover');
            if(tableRows.length > 0){
                const closeBtns = document.querySelectorAll('.btn-close');
                
                tableRows.forEach(row => {
                    const modalBtns = row.querySelectorAll('th a');
                    row.classList.remove('row_hover');
                    modalBtns.forEach(btn => {
                        btn.addEventListener('click', e => {
                            this.removeThatDangClass(tableRows);
                        })
                    })
                })
                closeBtns.forEach(btn => {
                    btn.addEventListener('click', e => {
                        this.removeThatDangClass(tableRows);
                    } )
                })
            }
        }, 1000);
    }

    removeThatDangClass(tableRows){
        tableRows.forEach(row => {
            row.classList.remove('row_hover');
        })
    }
}

export default SlateOverrides;